// assets
import {
  EyeOutlined,
  EditOutlined,
  HomeOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import PropertyRoundedIcon from "@mui/icons-material/ApartmentRounded";

// icons
const icons = {
  EyeOutlined,
  EditOutlined,
  HomeOutlined,
  ApartmentOutlined,
  PropertyRoundedIcon,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const accommodation = {
  id: "accommodation",
  title: "Accommodation",
  type: "group",
  children: [
    {
      id: "properties",
      title: "Properties",
      type: "collapse",
      url: "/properties",
      icon: icons.HomeOutlined,
      children: [
        {
          id: "edit-property",
          title: "Edit Property",
          type: "item",
          url: "/editProperty",
          icon: icons.EditOutlined,
          hidden: true,
        },
        {
          id: "show-property",
          title: "Property Data",
          type: "item",
          url: "/showProperty",
          icon: icons.EyeOutlined,
          hidden: true,
        },
      ],
    },
    {
      id: "units",
      title: "Units",
      type: "collapse",
      url: "/units",
      icon: icons.ApartmentOutlined,
      children: [
        {
          id: "edit-unit",
          title: "Edit Unit",
          type: "item",
          url: "/editUnit",
          icon: icons.EditOutlined,
          hidden: true,
        },
        {
          id: "show-Unit",
          title: "Unit Data",
          type: "item",
          url: "/showUnit",
          icon: icons.EyeOutlined,
          hidden: true,
        },
      ],
    },
  ],
};

export default accommodation;
